export const styles = {
  annotationContainer: {
    maxWidth: '70%',
  },

  loadingCanvas: {
    display: 'none',
  },
}
